// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611041306/js/" + chunkId + "." + {"44":"862b292f","225":"5fcca94b","481":"62d34bbb","486":"555dfcbb","770":"90a4895b"}[chunkId] + ".0.11110141922043493.chunk.js";
};